import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

interface Props {
  title: string;
  subTitle?: string;
  viewMode?: boolean;
}

const FinancialHeader: React.FC<Props> = ({ title, subTitle, viewMode }) => (
  <Box direction="column">
    <Text size="xxlarge" weight={400}>{title}</Text>
    {subTitle && (
      <Text
        size="medium"
        weight={400}
        margin={{ top: 'xxs', bottom: viewMode ? 'spacing16' : '0' }}
      > {subTitle}
      </Text>
    )}
  </Box>
);

export default FinancialHeader;
